// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#panel1d-header>div,#panel2d-header>div,#panel3d-header>div,#panel4d-header>div,#panel5d-header>div,#panel6d-header>div,#panel7d-header>div,#panel8d-header>div{align-items:center;display:flex}.drawn .box-list p{font-family:Open Sans;font-size:11px;font-weight:500;padding-right:32px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
